import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'COMISSAO_APURACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'COMISSAO_APURACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('comissaoApuracaoForm', registro)
    ];
}

export function getLista(data_inicial, data_final) {
	console.log(data_inicial);
	console.log(DateFormat.formatarDataTelaParaParametro(data_inicial));
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/reports/listarComissaoVariavel?data_inicial=${DateFormat.formatarDataTelaParaParametro(data_inicial)}&data_final=${DateFormat.formatarDataTelaParaParametro(data_final)}`)
		.then(resp => {
			dispatch({
		        type: 'COMISSAO_APURACAO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/comissaoApuracao`, {
				...registro,
				data_base: DateFormat.formatarDataTelaParaSql(registro.data_base),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/comissaoApuracao`, {
				...registro,
				data_base: DateFormat.formatarDataTelaParaSql(registro.data_base),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/comissaoApuracao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaComissaoOperacao() {
    const request = axios.get(`${consts.API_URL}/comissaoOperacao`);
    return {
        type: 'COMISSAO_APURACAO_OPERACAO_LISTADO',
        payload: request
    };
}

export function getListaComissaoTermo() {
    const request = axios.get(`${consts.API_URL}/comissaoTermo/listarSelect`);
    return {
        type: 'COMISSAO_APURACAO_TERMO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaComissaoVinculo() {
    const request = axios.get(`${consts.API_URL}/comissaoVinculo/listarSelect`);
    return {
        type: 'COMISSAO_APURACAO_VINCULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'COMISSAO_APURACAO_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaComissaoTipo() {
    const request = axios.get(`${consts.API_URL}/comissaoTipo/listarSelect`);
    return {
        type: 'COMISSAO_APURACAO_COMISSAO_SELECT_LISTADO',
        payload: request
    };
}